
import * as _ref_Li9qcy9maXJlYmFzZV9hdXRoLmpz_ from './js/firebase_auth.js';
import * as _ref_Li9qcy9wcm9qZWN0cy9maXJlYmFzZV9wcm9qZWN0X3VzZXJzLmpz_ from './js/projects/firebase_project_users.js';
import * as _ref_Li9qcy9wcm9qZWN0cy9maXJlYmFzZV9wcm9qZWN0cy5qcw_ from './js/projects/firebase_projects.js';
import * as Li9za2lrby5tanM from './skiko.mjs';
import * as _ref_QGpzLWpvZGEvY29yZQ_ from '@js-joda/core';
import { instantiate } from './PROMA-composeApp.uninstantiated.mjs';


const exports = (await instantiate({
    './js/firebase_auth.js': _ref_Li9qcy9maXJlYmFzZV9hdXRoLmpz_,
    './js/projects/firebase_project_users.js': _ref_Li9qcy9wcm9qZWN0cy9maXJlYmFzZV9wcm9qZWN0X3VzZXJzLmpz_,
    './js/projects/firebase_projects.js': _ref_Li9qcy9wcm9qZWN0cy9maXJlYmFzZV9wcm9qZWN0cy5qcw_,
    './skiko.mjs': Li9za2lrby5tanM,
    '@js-joda/core': _ref_QGpzLWpvZGEvY29yZQ_
})).exports;

export const {
memory,
_initialize
} = exports


